import React, { useEffect, Children } from 'react';
import { Header } from '../components/Header';
import { VideoPlayer } from '../components/VideoPlayer';
import { StatsSection } from '../components/StatsSection';
import { HeroHighlight, Highlight } from '../components/ui/HeroHighlight';
import { CalendlyEmbed } from '../components/CalendlyEmbed';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { ChevronLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function CompletionPage() {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  // Animation variants
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.1,
        duration: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      y: 20,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100,
        duration: 0.4
      }
    }
  };
  return <div className="w-full min-h-screen" data-id="element-101">
      <HeroHighlight data-id="element-102">
        <Header data-id="element-103" />
        <motion.main className="max-w-6xl mx-auto px-4" initial="hidden" animate="visible" variants={containerVariants} data-id="element-104">
          <motion.div id="headline" variants={itemVariants} data-id="element-105">
            <div className="flex justify-center mb-4 sm:mb-6 items-center" data-id="element-106">
              <div className="flex items-center" data-id="element-107">
                <motion.button onClick={() => navigate('/indeed')} className="mr-2 sm:mr-3 h-8 w-8 sm:h-9 sm:w-9 flex items-center justify-center rounded-full bg-white/5 backdrop-blur-sm border border-white/10 text-white hover:bg-white/10 transition-colors" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} data-id="element-108">
                  <ChevronLeftIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-109" />
                </motion.button>
                <div className="inline-flex items-center px-3 sm:px-6 py-1.5 sm:py-2 rounded-full border border-white/20 bg-white/5 backdrop-blur-sm" data-id="element-110">
                  <span className="text-xs sm:text-sm md:text-base font-medium text-white" data-id="element-111">
                    You're done!
                  </span>
                </div>
                {/* No forward arrow on completion page */}
              </div>
            </div>
            <h1 className="text-center text-2xl sm:text-4xl md:text-5xl font-bold mb-6 sm:mb-8 max-w-4xl mx-auto leading-[1.4] sm:leading-[1.3] text-white" data-id="element-112">
              Congratulations on completing your{' '}
              <Highlight data-id="element-113">HIRE Onboarding!</Highlight>
            </h1>
            <div className="mb-10 sm:mb-12" data-id="element-114">
              <p className="text-center text-base sm:text-xl mb-4 sm:mb-6 text-white" data-id="element-115">
                <strong data-id="element-116">Tap play on the video below</strong>
              </p>
              <VideoPlayer mediaId="ndynvonrfb" data-id="element-117" />
            </div>
          </motion.div>
          <motion.div id="stats" variants={itemVariants} data-id="element-118">
            <StatsSection data-id="element-119" />
          </motion.div>
          <motion.div id="faq" variants={itemVariants} data-id="element-120">
            <FAQSection data-id="element-121" />
          </motion.div>
          <Footer data-id="element-122" />
        </motion.main>
      </HeroHighlight>
    </div>;
}